import React, { Component } from 'react';
import { Card } from 'primereact/card';
import Fachada from './img/default_1.jpg'
import Formatacao from '@/app/util/formatacao'

import './obraCard.css'

const CampoOrcamento = props => (
    <div className="p-col-12">
        <span style={{fontWeight: 'bold'}}>{props.label}:</span> {props.value}
    </div>
)

export default class ObraCard extends Component {

  render() {
    const { numeroOrcamento, objetoObra, viproc, valor, dataConclusao, 
        tipoObra, prazo, inep, descricaoUnidadeTrabalho ,statusString,
        percentualExecucao, previsaoConclusao
    } = this.props.obra

    const tipo = tipoObra === 0 ? 'Construção' : 'Reforma'

    const header = (
        <img alt="Fachada" src={Fachada} width="100" height="150" />
    )

    return (
        <div className="obra-card">
            <a onClick={this.props.onClick}>
                <Card id={`${numeroOrcamento}`}
                    title={`${inep} - ${descricaoUnidadeTrabalho}`} 
                    subTitle={`Processo N° ${viproc}`} 
                    header={header} >
                    <div className="p-grid">
                        <CampoOrcamento label="Orcamento n°" value={numeroOrcamento} />
                        <CampoOrcamento label="Objeto da Obra" value={objetoObra} />
                        <CampoOrcamento label="Valor" value={Formatacao.currency(valor)} />
                        <CampoOrcamento label="Tipo Obra" value={tipo} />
                        <CampoOrcamento label="Prazo" value={`${prazo} dias`} />
                        {previsaoConclusao && 
                            <CampoOrcamento label="Previsão de Conclusão" value={previsaoConclusao} />
                        }
                        <CampoOrcamento label="Percentual de Execução" value={`${percentualExecucao} %`} />
                        <CampoOrcamento label="Situação" value={statusString} />
                    </div>
                </Card>
            </a>
        </div>        
    )
  }
}
